import { useState } from "react";
import "./Sidebar.css";
import SidebarLogo from "./SidebarLogo.jsx";
import SidebarNav from "./SidebarNav.jsx";
import SidebarRecents from "./SidebarRecents.jsx";
import SidebarFooter from "./SidebarFooter.jsx";
import SidebarResizer from "./SidebarResizer.jsx";
import { useSidebarWidth } from "./useSidebarWidth.js";
import { ROUTES } from "../../constants/routes.js";
import useIsMobile from "../../hooks/useIsMobile.js";
import { useMobileShell } from "../../context/useMobileShell.js";

export default function SidebarLayout({
  newTaskPath = ROUTES.TASK,
  onNavigate,
  navItems,
  recentTasks,
  recentsLoading,
  onTaskDeleted,
  footerItems,
}) {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [width, setWidth] = useSidebarWidth(280);
  const isMobile = useIsMobile();
  const { isDrawerOpen, closeDrawer } = useMobileShell();

  // When the sidebar is collapsed we don't render the resizer and we
  // let CSS govern the rail width. On expanded, the inline style
  // overrides the CSS default so user-chosen widths stick through
  // route changes and reloads.
  //
  // On mobile the sidebar becomes a drawer (Sidebar.css mobile block):
  // ignore the user's resized desktop width and the collapsed-rail
  // class entirely, so the CSS-controlled drawer width / position rule
  // wins without needing !important.
  const desktopStyle = isCollapsed ? undefined : { width: `${width}px` };
  const style = isMobile ? undefined : desktopStyle;
  const collapsedClass = !isMobile && isCollapsed ? " collapsed" : "";
  const drawerClass = isMobile
    ? ` sidebar--drawer${isDrawerOpen ? " sidebar--drawer-open" : ""}`
    : "";

  return (
    <>
      {/* Drawer backdrop — only painted on mobile. Click anywhere
          outside the sliding panel to dismiss. Aria-hidden because
          the trigger lives on the MobileTopBar burger. */}
      {isMobile ? (
        <div
          className={`sidebar-backdrop${isDrawerOpen ? " is-open" : ""}`}
          onClick={closeDrawer}
          aria-hidden="true"
        />
      ) : null}
      <aside
        id="app-sidebar"
        className={`sidebar${collapsedClass}${drawerClass}`}
        style={style}
        aria-hidden={isMobile && !isDrawerOpen ? "true" : undefined}
      >
        <SidebarLogo isCollapsed={!isMobile && isCollapsed} />
        <SidebarNav
          newTaskPath={newTaskPath}
          onNavigate={onNavigate}
          items={navItems}
          isCollapsed={!isMobile && isCollapsed}
        />
        <SidebarRecents recentTasks={recentTasks} loading={recentsLoading} onTaskDeleted={onTaskDeleted} />
        <SidebarFooter
          footerItems={footerItems}
          onNavigate={onNavigate}
          isCollapsed={!isMobile && isCollapsed}
          onToggleCollapsed={isMobile ? undefined : () => setIsCollapsed((prev) => !prev)}
        />
      </aside>
      <SidebarResizer onChange={setWidth} disabled={isCollapsed || isMobile} />
    </>
  );
}

